export const KG = {
  bg:        '#0c0c0c',
  panel:     '#141416',
  panel2:    '#1a1a1d',
  card:      '#202024',
  cardHi:    '#26262b',
  border:    'rgba(255,255,255,0.08)',
  borderHi:  'rgba(255,255,255,0.14)',
  text:      '#f5f5f5',
  text2:     '#cfcfd3',
  hint:      '#808088',
  hint2:     '#5a5a62',
  blue:      '#2565eb',
  blueSoft:  'rgba(37,101,235,0.15)',
  purple:    '#8a2bb6',
  purpleSoft:'rgba(138,43,182,0.18)',
  pink:      '#e94e8a',
  pinkSoft:  'rgba(233,78,138,0.18)',
  gold:      '#f5c542',
  red:       '#ec3942',
  green:     '#2ecc71',
  online:    '#22c55e',
} as const;

export type DesktopNavId = 'discover' | 'wall' | 'events' | 'groups' | 'chat';

export interface DesktopNavItem {
  id: DesktopNavId;
  label: string;
  emoji: string;
  glow: string;
  route: string;
  matches: (path: string) => boolean;
}

export const DESKTOP_NAV: DesktopNavItem[] = [
  {
    id: 'discover',
    label: 'Scopri',
    emoji: '🧭',
    glow: '255,225,80',
    route: '/discover',
    matches: (p) => p === '/' || p.startsWith('/discover'),
  },
  {
    id: 'wall',
    label: 'Wall',
    emoji: '🔮',
    glow: '138,43,226',
    route: '/wall',
    matches: (p) => p.startsWith('/wall'),
  },
  {
    id: 'events',
    label: 'Eventi',
    emoji: '🎟️',
    glow: '255,215,0',
    route: '/events',
    matches: (p) => p.startsWith('/events'),
  },
  {
    id: 'groups',
    label: 'Gruppi',
    emoji: '🎭',
    glow: '200,80,200',
    route: '/groups',
    matches: (p) => p.startsWith('/groups'),
  },
  {
    id: 'chat',
    label: 'Chat',
    emoji: '💬',
    glow: '45,165,255',
    route: '/chat',
    matches: (p) => p.startsWith('/chat'),
  },
];

export const DESKTOP_SECONDARY: { label: string; emoji: string; route?: string }[] = [
  { label: 'Profilo',       emoji: '👤' },
  { label: 'Speed dates',   emoji: '⚡', route: '/speed' },
  { label: 'Travels',       emoji: '✈️' },
  { label: 'Impostazioni',  emoji: '⚙️' },
];
